import moment from 'moment';
import * as types from '../../constants/actionsType'

const initialState = {
  licenseSummary: {
    head: [],
    body: []
  },
  isLoadLicenseSummary: true,
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SUCCESS_LICENSE:
      var data = action.data.map(i => {
        return [i.licenseKeyNo, i.institutionID, i.noOfUsers, i.bonusUsers, i.validFrom, i.validTo, i.gracePeriod + " days", i.active ? "Active" : "In Active"]
      })

      return {
        ...state,
        licenseSummary: {
          head: [
            {
              label: 'License Key No',
              align: 'left'
            },
            {
              label: 'Institution Code',
              align: 'left',
            },
            {
              label: 'No Of Users',
              align: 'right',
            },
            {
              label: 'Bonus Users',
              align: 'right',
            },
            {
              label: 'Valid From',
              align: 'left',
            },
            {
              label: 'Valid To',
              align: 'left',
            },
            {
              label: 'Grace Period',
              align: 'left',
            },
            {
              label: 'Status',
              align: 'left',
            },

          ],
          body: data,
        },
        isLoadLicenseSummary: false,
      }
    case types.FAILED_LICENSE:
      return {
        ...state,
        licenseSummary: {
          head: [],
          body: []
        },
        isLoadLicenseSummary: false,
      }
    case types.FETCH_LICENSE:
      return {
        ...state,
        licenseSummary: {
          head: [],
          body: []
        },
        isLoadLicenseSummary: true,
      }
    default:
      return state
  }
}
export default reducer